export const RECEIVE_WELCOME_MESSAGE = "RECEIVE_WELCOME_MESSAGE";
